import React from 'react';
import PropTypes from 'prop-types';
import PostedPrice from './posted-price';
import NoPrice from './no-price';
import UpdatePrice from './update-price';
import styles from './styles.css';
import PriceProps from '../../../utils/prop-types/fuel-price';

const formatPrice = (price, country) => {
  let priceMultiplier = 100;
  let numberOfDecimalPlaces = 2;
  if (country === 'CA') {
    priceMultiplier = 10;
    numberOfDecimalPlaces = 1;
  }
  return ((price * priceMultiplier) / priceMultiplier).toFixed(numberOfDecimalPlaces);
};

class PriceItem extends React.Component {
  static propTypes = {
    price: PriceProps.isRequired,
    currentStationPrice: PriceProps.isRequired,
    onUpdatePriceClick: PropTypes.func,
    onPriceBlur: PropTypes.func.isRequired,
    isEditing: PropTypes.bool,
    country: PropTypes.string.isRequired,
    fuelProduct: PropTypes.string.isRequired,
    priceType: PropTypes.string.isRequired,
  };

  static defaultProps = {
    onUpdatePriceClick: () => {},
    isEditing: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      isEditing: props.isEditing,
      price: props.price,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { isEditing: isEditingState } = this.state;
    const { isEditing: nextIsEditingState } = nextState;

    const { country, isEditing } = this.props;
    const { country: nextCountry, isEditing: nextIsEditing } = nextProps;

    return (isEditingState !== nextIsEditingState) || (country !== nextCountry) || (isEditing !== nextIsEditing);
  }

  componentDidUpdate(prevProps) {
    const { isEditing: isEditingFromProps } = this.props;
    const { isEditing } = prevProps;
    if (isEditing !== isEditingFromProps) {
      this.setState(() => ({
        isEditing: isEditingFromProps,
      }));
    }
  }

  onPriceBlur = (price) => {
    const { price: priceFromProps, fuelProduct, priceType } = this.props;
    this.props.onPriceBlur(Object.assign({}, priceFromProps, { price: Number(price) }, { fuel_product: fuelProduct }, { price_type: priceType }));
  };

  render = () => {
    const { onUpdatePriceClick, country, currentStationPrice } = this.props;
    const { isEditing, price } = this.state;

    let priceToDisplay = (<NoPrice onUpdatePriceClick={onUpdatePriceClick} />);
    if (isEditing) {
      priceToDisplay = (<UpdatePrice price={price} currentStationPrice={currentStationPrice} country={country} onPriceBlur={this.onPriceBlur} />);
    } else if (currentStationPrice?.price) {
      priceToDisplay = (<PostedPrice price={currentStationPrice} country={country} />);
    }

    return (
      <div className={styles.priceItem}>
        {priceToDisplay}
      </div>
    );
  }
}

export { PriceItem as default, formatPrice };
